import { useTranslate } from '@tolgee/react'
import { useParams } from 'next/navigation'
import Button from '@/components/common/Button'
import React, { ReactNode } from 'react'
import { cn } from 'oddle-shop-monorepo.design-system'

interface LinkButtonProps {
  href: string
  previewMode: boolean
  children: React.ReactNode
  className?: string
}

const LinkButton = ({
  href,
  previewMode,
  children,
  className,
}: LinkButtonProps): ReactNode => {
  const { t } = useTranslate()
  const params = useParams()
  const locale = (params?.locale as string) || ''
  const link = href?.charAt(0) === '/' ? `/${locale}${href}` : href
  return (
    <a
      href={link}
      onClick={(e) => {
        if (!previewMode || !href) return
        e.preventDefault()
        if (
          window.confirm(
            t(
              'This link cannot be opened in customisation preview. It will be opened in a new window ({target}).\nClick OK to continue',
              { target: href }
            )
          )
        ) {
          window.open(href, '_blank')
        }
      }}
    >
      <Button className={cn('mx-1 mb-0 mt-4', className)}>{children}</Button>
    </a>
  )
}

LinkButton.displayName = 'LinkButton'

export default LinkButton
